import { WrappedCheckbox as Checkbox } from '@alfa-bank/site-checkbox/checkbox';
import { Link } from '@alfa-bank/site-link';
import { ModalDesktop as Modal } from '@alfa-bank/site-modal/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { AgreementCheckbox as Component } from '../agreement-checkbox';
import type { TAgreementCheckbox, IDeps } from '../models';

export const AgreementCheckboxDesktop = createWidget<IDeps, TAgreementCheckbox>({
    Checkbox,
    Link,
    Modal,
    sendEvent,
})(Component);
